import * as React from 'react';

export function DropboxSVG(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="current"
            height="current"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            {...props}
        >
            <path
                d="M10.25 5.656L6.125 3 2 5.656 6.125 8.25 2 10.906l4.125 2.656 4.125-2.656-4.125-2.625 4.125-2.625zm-4.156 8.719L10.219 17l4.125-2.625-4.125-2.625-4.125 2.625zm4.156-3.469l4.094 2.656 4.156-2.656-4.156-2.625L18.5 5.656 14.344 3 10.25 5.656l4.125 2.594-4.125 2.656z"
                fill="current"
            />
        </svg>
    );
}
